import { render } from "./Vdo.vue?vue&type=template&id=5d38c9a0"
const script = {}
script.render = render

export default script